/**
 * VIP badge — gold-tint background with vip-ink text, mono caps.
 * Render only when `customer.vip` is true.
 */
export function VipBadge(): React.JSX.Element {
  return (
    <span className="inline-flex items-center h-4.5 px-1.75 rounded-sm bg-vip-tint text-vip-ink font-mono text-2xs font-semibold tracking-wider">
      VIP
    </span>
  );
}
